"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpPrinterStatusSource = void 0;
const http_polling_source_1 = require("@dqm/http-polling-source");
class HttpPrinterStatusSource extends http_polling_source_1.HttpPollingSource {
    constructor(fetchUrl, options = {}) {
        if (options.pollInterval === undefined) {
            options.pollInterval = 5000;
        }
        super(fetchUrl, options);
    }
}
exports.HttpPrinterStatusSource = HttpPrinterStatusSource;
//# sourceMappingURL=HttpPrinterStatusSource.js.map